import {dashParseSubs} from '@player/src/mixins';
export {SubtitleController};

class SubtitleController{
    constructor({videoTag,hub}){
        if(videoTag instanceof HTMLVideoElement){
            this.tracks=[];
            this._videoTag=videoTag;
            this._hub=hub;
            this._trackTag=null;
            this._cueListener=this._cueListener.bind(this);//binding listener to instance.
        }
        else throw new Error('videoTag missing in SubtitleController constructor.');
    }
    addTrack({src,lang='en'}){
        if(!src){
            return console.warn('no src available to add subtitle track.');
        }
        this.removeTrack();
        for(let texttrack of [...this._videoTag.textTracks]){
            texttrack.mode='disabled'; //disable active cues.
        }
        this._trackTag=this._createTrack({src,lang});
        this._toggleListener(true);
        this._videoTag.append(this._trackTag);
        this._trackTag.track.mode='hidden'; //hide track mode after append.
    }

    removeTrack(){
        if(!this._trackTag)return null;

        this._toggleListener(false);
        this._trackTag.remove();
        this._trackTag=null;
        this._hub.dispatch('cue-change-texts',[]);
    }

    async loadSubtitles(){
        this.tracks=await this.fetchSubtitles(...arguments);
    }
    async fetchSubtitles(content,playerType){
        try{
            if(content.subtitles.length)return content.subtitles.map(sub=>sub.lang);
            
            let subsArray=[],source=content.getSource();

            const sourceText=await fetch(source).then(res=>res.text());
            
            if(playerType==='dashPlayer')subsArray=dashParseSubs(sourceText,source);
            
            return subsArray;
        }
        catch(e){
            console.warn('subtitles fetch error.',e);
            return [];
        }
    }

    destroy(){
        this.removeTrack();
        this._videoTag=null;
        this._hub=null;
    }

    _createTrack({src,lang}){
        let track=document.createElement('track');
        track.kind='metadata';
        track.default=true;
        track.src=src;
        track.srclang=lang;
        return track;
    }

    _toggleListener(toggleval){
        let method=toggleval?'addEventListener':'removeEventListener';
        this._trackTag?.[method]('cuechange',this._cueListener);
    }

    _cueListener(){
        let cuesTexts=[...this._trackTag.track.activeCues??[]].map(cue=>cue.text).filter(text=>!!text);
        this._hub.dispatch('cue-change-texts',cuesTexts);
    }
   

}